export const getDate = (dateString: string) => {
  const options = {
    hour: "numeric",
    minute: "numeric",
  };
  const date = new Date(dateString);
  return date.toLocaleDateString("de-DE", options);
};
